import { useState, useCallback } from "react";

const useToast = () => {
    const [toast, setToast] = useState({ show: false, message: "", type: "success" });

    const showToast = useCallback((message, type = "success") => {
        setToast({ show: true, message, type });
    }, []);

    const hideToast = useCallback(() => {
        setToast({ show: false, message: "", type: "success" });
    }, []);

    return { toast, showToast, hideToast };
};

export default useToast;
